import React, {useContext, useEffect, useState} from 'react';
import {Helmet} from "react-helmet";

import './refoundAndDelivery.css';
import {observer} from "mobx-react-lite";
import {Context} from "../../../index";
import PageRefound from "../../../components/DeliveryAndRefound/BlockRefound/PageRefound";
import {getOnePageContent} from "../../../http/contentApi";


const RefoundAndDelivery = observer(() => {
    const {settings} = useContext(Context)
    const [deliveryNoJson, setDeliveryNoJson] = useState({})

    useEffect(() => {
        window.scrollTo(0, 0)

        getOnePageContent(10).then(response => {
            if (response.content) {
                setDeliveryNoJson(JSON.parse(response.content))
            }
        })
    }, [])

    return (
        <div
            style={{marginTop: settings.headerHeight}}
            className={"refound_and_delivery"}>
            <Helmet>
                <title>{deliveryNoJson.titleRefound ? deliveryNoJson.titleRefound : ""}</title>
                <meta name="description" content={deliveryNoJson.descriptionRefound ? deliveryNoJson.descriptionRefound : ""}/>
            </Helmet>
            <div className={"refound_and_delivery_child"}>
                <div className={"conteiner_banner"}>
                    <div className={"title_and_categories"}>
                        <h1 className={"title_delivery"}>{deliveryNoJson.nameRefound}</h1>
                    </div>
                </div>
                <PageRefound
                    deliveryNoJson={deliveryNoJson}
                />
            </div>
        </div>
    );
});

export default RefoundAndDelivery;